/**
 * LED IDÉES CLAIRES — Compatibility Selector v2.2 (Mission UX LED + Demande contextualisée)
 * READ-ONLY engine layer. Consumes pre-built runtime data (lic-runtime-*.json).
 * Does NOT invent compatibility/positions/bulbs. Position comes only from fitment index.
 * Commercial states and rules strictly preserved from validated Missions 10B–15.1.
 */
(function () {
  "use strict";

  var POSITION_LABELS = {
    dipped: "Feux de croisement",
    main: "Feux de route",
    fog_front: "Antibrouillards avant",
    position: "Feux de position",
    drl: "Feux de jour",
    turn_front: "Clignotants avant",
    turn_rear: "Clignotants arrière",
    turn_side: "Clignotants latéraux",
    reverse: "Feux de recul",
    brake: "Feux stop",
    brake_center: "3ème feu stop central",
    plate: "Éclairage de plaque",
    fog_rear: "Antibrouillard arrière",
    cornering: "Feux de virage"
  };

  var POSITION_ORDER = [
    "dipped",
    "main",
    "fog_front",
    "position",
    "drl",
    "turn_front",
    "turn_rear",
    "turn_side",
    "reverse",
    "brake",
    "brake_center",
    "plate",
    "fog_rear",
    "cornering"
  ];

  var BASE = (window.LIC_SELECTOR_BASE || "/assets/").replace(/\/+$/, "") + "/";
  var state = {
    vehicles: null,
    products: null,
    brandFitment: null,
    brand: null,
    model: null,
    year: null,
    vehicleKey: null,
    position: null
  };

  function track(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: "lic_" + event }, payload || {}));
    } catch (e) {}
  }

  function safe(s) {
    return String(s || "").toUpperCase().replace(/[^A-Z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  }

  function getJSON(url) {
    return fetch(url, { credentials: "same-origin" }).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function el(root, sel) {
    return root.querySelector(sel);
  }

  function setOptions(select, items, labelKey, valueKey, placeholder) {
    select.innerHTML = "";
    var o = document.createElement("option");
    o.value = "";
    o.textContent = placeholder || "Sélectionner";
    select.appendChild(o);
    items.forEach(function (it) {
      var op = document.createElement("option");
      op.value = typeof valueKey === "function" ? valueKey(it) : it[valueKey];
      op.textContent = typeof labelKey === "function" ? labelKey(it) : it[labelKey];
      select.appendChild(op);
    });
    select.disabled = items.length === 0;
  }

  function init(root) {
    var brandEl = el(root, "[data-v2-brand]");
    var modelEl = el(root, "[data-v2-model]");
    var yearEl = el(root, "[data-v2-year]");
    var disambigEl = el(root, "[data-v2-disambig]");
    var disambigSelectEl = el(root, "[data-v2-disambig-select]");
    var posEl = el(root, "[data-v2-position]");
    var pillsContainer = el(root, "[data-v2-pos-pills]");
    var resultEl = el(root, "[data-v2-result]");
    var msgEl = el(root, "[data-v2-msg]");
    var progress = root.querySelectorAll("[data-v2-step]");

    if (!brandEl || !modelEl || !yearEl || !posEl || !resultEl) return;

    function setStep(n) {
      progress.forEach(function (p) {
        p.classList.toggle("is-active", Number(p.getAttribute("data-v2-step")) <= n);
      });
    }

    function msg(t, warn) {
      if (!msgEl) return;
      msgEl.hidden = !t;
      msgEl.textContent = t || "";
      msgEl.classList.toggle("is-warn", !!warn);
    }

    function updatePills() {
      if (!pillsContainer) return;
      var cur = posEl.value;
      pillsContainer.querySelectorAll(".lic-v2__pos-pill").forEach(function (pill) {
        var match = pill.getAttribute("data-pos") === cur;
        pill.classList.toggle("is-active", match);
        pill.setAttribute("aria-pressed", match ? "true" : "false");
      });
    }

    function clearFromModel() {
      modelEl.innerHTML = '<option value="">Choisir le modèle</option>';
      modelEl.disabled = true;
      clearFromYear();
    }

    function clearFromYear() {
      yearEl.innerHTML = '<option value="">Choisir l\'année</option>';
      yearEl.disabled = true;
      clearFromDisambig();
    }

    function clearFromDisambig() {
      if (disambigEl) disambigEl.hidden = true;
      if (disambigSelectEl) {
        disambigSelectEl.innerHTML = '<option value="">Choisir la version</option>';
        disambigSelectEl.disabled = true;
      }
      state.vehicleKey = null;
      clearFromPosition();
    }

    function clearFromPosition() {
      posEl.innerHTML = '<option value="">Sélectionner le feu à équiper</option>';
      posEl.disabled = true;
      if (pillsContainer) {
        pillsContainer.innerHTML = "";
        pillsContainer.hidden = true;
      }
      resultEl.innerHTML = "";
      resultEl.hidden = true;
      state.position = null;
    }

    // Chargement initial des index (véhicules + catalogue produits)
    Promise.all([
      getJSON(BASE + "lic-runtime-vehicles.json"),
      getJSON(BASE + "lic-runtime-products.json")
    ]).then(function (res) {
      state.vehicles = res[0];
      state.products = res[1];
      if (!state.vehicles) {
        msg("Données de compatibilité temporairement indisponibles.", true);
        return;
      }
      var brands = Object.keys(state.vehicles).sort();
      setOptions(brandEl, brands.map(function (b) { return { b: b }; }), "b", "b", "Choisir la marque");
      setStep(1);
      track("selector_started");
    });

    // Étape 1 : Changement de marque
    brandEl.addEventListener("change", function () {
      state.brand = brandEl.value;
      clearFromModel();
      state.brandFitment = null;
      if (!state.brand) return;
      track("brand_selected", { brand: state.brand });

      var models = Object.keys(state.vehicles[state.brand] || {}).sort();
      setOptions(modelEl, models.map(function (m) { return { m: m }; }), "m", "m", "Choisir le modèle");
      
      // Chargement lazy du fitment de la marque
      getJSON(BASE + "lic-runtime-brand-" + safe(state.brand) + ".json").then(function (d) {
        state.brandFitment = d || {};
      });
      setStep(1);
    });

    // Étape 2 : Changement de modèle
    modelEl.addEventListener("change", function () {
      state.model = modelEl.value;
      clearFromYear();
      if (!state.model) return;
      track("model_selected", { brand: state.brand, model: state.model });

      var cfgs = state.vehicles[state.brand][state.model] || [];
      var years = uniq(cfgs.map(function (c) { return c.year; })).filter(Boolean).sort();
      setOptions(yearEl, years.map(function (y) { return { y: y }; }), "y", "y", "Choisir l'année");
      setStep(2);
    });

    // Étape 3 : Changement d'année
    yearEl.addEventListener("change", function () {
      state.year = yearEl.value;
      clearFromDisambig();
      if (!state.year) return;
      track("year_selected", { brand: state.brand, model: state.model, year: state.year });

      var cfgs = state.vehicles[state.brand][state.model] || [];
      var matched = cfgs.filter(function (c) { return c.year === state.year; });
      if (matched.length === 0) {
        msg("Configuration non répertoriée pour cette année.", true);
        return;
      }

      // Analyse de désambiguïsation conditionnelle
      var distinctKeys = uniq(matched.map(function (c) { return c.vehicle_key; }));

      if (distinctKeys.length === 1) {
        // CAS A : Une seule configuration technique résolue -> sélection automatique transparente
        state.vehicleKey = distinctKeys[0];
        if (disambigEl) disambigEl.hidden = true;
        renderPositions();
        setStep(3);
      } else {
        // CAS B : Plusieurs configurations d'éclairage distinctes possibles -> désambiguïsation
        if (disambigEl) disambigEl.hidden = false;
        var options = matched.map(function (c) {
          var labelParts = [];
          if (c.engine) labelParts.push(c.engine);
          if (c.technology && c.technology !== "Standard") labelParts.push(c.technology);
          var label = labelParts.join(" — ") || c.engine || "Version standard";
          return { key: c.vehicle_key, label: label };
        });
        setOptions(disambigSelectEl, options, "label", "key", "Choisir la version");
        disambigSelectEl.disabled = false;
        setStep(3);
      }
    });

    // Étape conditionnelle : Sélection de version / désambiguïsation
    if (disambigSelectEl) {
      function onDisambigChange() {
        clearFromPosition();
        state.vehicleKey = disambigSelectEl.value;
        if (!state.vehicleKey) return;
        renderPositions();
        setStep(3);
      }
      disambigSelectEl.addEventListener("change", onDisambigChange);
      disambigSelectEl.addEventListener("input", onDisambigChange);
    }

    // Étape 4 : Détermination et affichage dynamique des feux disponibles
    function renderPositions() {
      msg("");
      var f = state.brandFitment || {};
      var vehicleEntries = [];
      Object.keys(f).forEach(function (k) {
        if (f[k].vehicle_key === state.vehicleKey) {
          vehicleEntries.push(f[k]);
        }
      });

      // Filtrer : Uniquement les positions pertinentes pour notre catalogue LED
      var availablePositions = vehicleEntries.filter(function (e) {
        return !!POSITION_LABELS[e.position];
      });

      // Trier selon l'ordre commercial prioritaire
      availablePositions.sort(function (a, b) {
        var idxA = POSITION_ORDER.indexOf(a.position);
        var idxB = POSITION_ORDER.indexOf(b.position);
        if (idxA === -1) idxA = 999;
        if (idxB === -1) idxB = 999;
        return idxA - idxB;
      });

      if (!availablePositions.length) {
        msg("Aucun feu référencé pour cette configuration.", true);
        setOptions(posEl, [], "label", "value", "Aucun feu disponible");
        if (pillsContainer) {
          pillsContainer.innerHTML = "";
          pillsContainer.hidden = true;
        }
        return;
      }

      setOptions(
        posEl,
        availablePositions.map(function (p) {
          return { value: p.position, label: POSITION_LABELS[p.position] || p.position };
        }),
        "label",
        "value",
        "Sélectionner le feu à équiper"
      );

      // Génération des pills boutons rapides
      if (pillsContainer) {
        pillsContainer.innerHTML = "";
        availablePositions.forEach(function (p) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "lic-v2__pos-pill";
          btn.setAttribute("data-pos", p.position);
          btn.textContent = POSITION_LABELS[p.position] || p.position;
          btn.addEventListener("click", function () {
            posEl.value = p.position;
            updatePills();
            posEl.dispatchEvent(new Event("change"));
          });
          pillsContainer.appendChild(btn);
        });
        pillsContainer.hidden = false;
      }

      setStep(4);
    }

    // Étape 5 : Sélection du feu et affichage du résultat centré sur l'ampoule
    posEl.addEventListener("change", function () {
      state.position = posEl.value;
      updatePills();
      if (!state.position) {
        resultEl.innerHTML = "";
        resultEl.hidden = true;
        return;
      }
      track("position_selected", { position: state.position });

      var key = state.vehicleKey + "|" + state.position;
      var e = (state.brandFitment || {})[key];
      if (!e) {
        resultEl.innerHTML = box("<p>Cette fonction d'éclairage n'est pas référencée pour cette configuration.</p>", "warn");
        resultEl.hidden = false;
        return;
      }
      render(e);
    });

    function prodLabel(h) {
      var p = (state.products || {})[h];
      return p ? (p.family + " " + p.bulb) : h;
    }

    function box(html, cls) {
      return '<div class="lic-v2-card ' + (cls || "") + '">' + html + "</div>";
    }

    // Construction de l'URL vers la page de demande contextualisée
    function buildRequestUrl(e, requestType) {
      var baseUrl = window.LIC_AVAILABILITY_URL || "/pages/demande-compatibilite";
      var params = new URLSearchParams();
      if (state.brand) params.set("brand", state.brand);
      if (state.model) params.set("model", state.model);
      if (state.year) params.set("year", state.year);

      var configStr = "";
      if (state.vehicleKey) {
        var parts = state.vehicleKey.split("|");
        if (parts.length >= 5) {
          configStr = parts[2];
          if (parts[4] && parts[4] !== "Standard") {
            configStr += " (" + parts[4] + ")";
          }
        }
      }
      if (configStr) params.set("configuration", configStr);
      if (e.position) params.set("position", e.position);
      params.set("original_bulb", e.original_bulb || "");
      params.set("status", e.status || "");
      if (e.source_level) params.set("source_level", e.source_level);
      if (requestType) params.set("request_type", requestType);

      try {
        var currentParams = new URLSearchParams(window.location.search);
        if (currentParams.has("preview_theme_id")) {
          params.set("preview_theme_id", currentParams.get("preview_theme_id"));
        }
      } catch (err) {}
      params.set("view", "lic-availability-request");
      var delimiter = baseUrl.indexOf("?") === -1 ? "?" : "&";
      return baseUrl + delimiter + params.toString();
    }

    function cta(label, e, requestType, isPrimary) {
      var href = buildRequestUrl(e, requestType);
      var btnClass = isPrimary ? "lic-v2-cta lic-v2-cta--full" : "lic-v2-cta lic-v2-cta--ghost";
      return '<a class="' + btnClass + '" data-v2-lead="' + esc(requestType) + '" href="' + esc(href) + '">' + esc(label) + "</a>";
    }

    function render(e) {
      var bulb = (e.original_bulb || "").trim();
      var hasBulb = bulb.length > 0;
      var posName = POSITION_LABELS[e.position] || e.position;

      // En-tête centré sur le véhicule et le feu
      var headHtml =
        '<div class="lic-v2-result-header">' +
          '<div class="lic-v2-result-kicker">Votre configuration</div>' +
          '<div class="lic-v2-result-vehicle">' + esc(state.brand) + " " + esc(state.model) + (state.year ? " &bull; " + esc(state.year) : "") + '</div>' +
          '<div class="lic-v2-result-position">' + esc(posName) + '</div>' +
        '</div>';

      // Bloc ampoule d'origine — RÈGLE STRICTE : NE JAMAIS INVENTER UNE AMPOULE
      var bulbHtml = "";
      if (hasBulb) {
        bulbHtml =
          '<div class="lic-v2-bulb-box">' +
            '<span class="lic-v2-bulb-label">Ampoule d\'origine :</span>' +
            '<span class="lic-v2-bulb-tag">' + esc(bulb) + '</span>' +
          '</div>';
      } else {
        bulbHtml =
          '<div class="lic-v2-bulb-box lic-v2-bulb-box--unproven">' +
            '<span class="lic-v2-bulb-label">Ampoule d\'origine :</span>' +
            '<span class="lic-v2-bulb-tag lic-v2-bulb-tag--unproven">Non documentée</span>' +
          '</div>';
      }

      var html = "";

      // 1. CAS AVAILABLE_FOR_PURCHASE : Achat direct UNIQUEMENT si status === AVAILABLE_FOR_PURCHASE AND product_id AND variant_id
      if (e.status === "AVAILABLE_FOR_PURCHASE" && e.products && e.products.length) {
        var cards = e.products.map(function (pr) {
          var p = (state.products || {})[pr.handle] || {};
          var confirmed = p.identity_status === "CONFIRMED" || (p.product_id && p.variant_id);
          var url = confirmed ? (p.shopify_url || p.url) : "";
          var ctaHtml = confirmed
            ? '<a class="lic-v2-cta lic-v2-cta--buy" href="' + esc(url) + '" data-v2-product="' + esc(pr.handle) + '">Voir l\'ampoule LED</a>'
            : '<span class="lic-v2-warn">Fiche produit en cours de validation</span>';
          return (
            '<div class="lic-v2-product-card">' +
              '<div class="lic-v2-product-meta">' +
                '<span class="lic-v2-solution-badge">Solution LED compatible</span>' +
                '<h4 class="lic-v2-product-title">' + esc(prodLabel(pr.handle)) + '</h4>' +
              '</div>' +
              ctaHtml +
            '</div>'
          );
        }).join("");

        html = box(
          '<div class="lic-v2-status lic-v2-status--ok">✓ Compatibilité confirmée</div>' +
          headHtml +
          bulbHtml +
          '<div class="lic-v2-solutions-wrap">' +
            '<div class="lic-v2-solutions-title">Solution LED</div>' +
            '<div class="lic-v2-prods-grid">' + cards + '</div>' +
          '</div>'
        );
        track("available_result", { position: e.position, bulb: e.original_bulb });

      // 2. CAS LEVEL B : Ampoule non documentée avec certitude (AUCUN ACHAT DIRECT)
      } else if (!hasBulb || e.source_level === "LEVEL_B") {
        html = box(
          '<div class="lic-v2-status lic-v2-status--verify">Ampoule non documentée</div>' +
          headHtml +
          bulbHtml +
          '<div class="lic-v2-explanation">' +
            '<h4 class="lic-v2-explanation__title">Solution LED</h4>' +
            '<p>Emplacement identifié, mais référence d\'ampoule d\'origine non documentée avec certitude pour cette finition.</p>' +
          '</div>' +
          cta("Être informé dès qu'une solution est disponible", e, "NOTIFY_AVAILABILITY", true)
        );
        track("unproven_result", { position: e.position });

      // 3. CAS REQUIRES_VERIFICATION : Vérification préalable conseillée (AUCUN ACHAT DIRECT)
      } else if (e.status === "REQUIRES_VERIFICATION") {
        html = box(
          '<div class="lic-v2-status lic-v2-status--verify">⚠ Vérification préalable conseillée</div>' +
          headHtml +
          bulbHtml +
          '<div class="lic-v2-explanation">' +
            '<h4 class="lic-v2-explanation__title">Solution LED</h4>' +
            '<p>Cette compatibilité nécessite une vérification par nos techniciens avant achat.</p>' +
          '</div>' +
          cta("Demander une vérification", e, "VERIFY_COMPATIBILITY", true)
        );
        track("verification_result", { position: e.position, bulb: e.original_bulb });

      // 4. CAS PRODUCT_NOT_AVAILABLE : LED non disponible actuellement (AUCUN ACHAT DIRECT)
      } else if (e.status === "PRODUCT_NOT_AVAILABLE") {
        html = box(
          '<div class="lic-v2-status lic-v2-status--warn">LED non disponible actuellement</div>' +
          headHtml +
          bulbHtml +
          '<div class="lic-v2-explanation">' +
            '<h4 class="lic-v2-explanation__title">Solution LED</h4>' +
            '<p>Nous n\'avons pas actuellement de référence LED correspondante dans notre catalogue pour ce feu.</p>' +
          '</div>' +
          '<div class="lic-v2-actions-group">' +
            cta("Être informé de la disponibilité", e, "NOTIFY_AVAILABILITY", true) +
            cta("Demander une alternative", e, "ALTERNATIVE", false) +
            cta("Demander une commande spéciale", e, "SPECIAL_ORDER", false) +
          '</div>',
          "warn"
        );
        track("no_product_result", { position: e.position, bulb: e.original_bulb });

      // 5. CAS BLOCKED_SOURCE_CONFLICT : Vérification obligatoire (AUCUN ACHAT DIRECT)
      } else if (e.status === "BLOCKED_SOURCE_CONFLICT") {
        html = box(
          '<div class="lic-v2-status lic-v2-status--block">Vérification obligatoire</div>' +
          headHtml +
          bulbHtml +
          '<div class="lic-v2-explanation">' +
            '<h4 class="lic-v2-explanation__title">Solution LED</h4>' +
            '<p>Les sources disponibles présentent une divergence pour cette configuration. Nous vérifions votre feu avant expédition.</p>' +
          '</div>' +
          cta("Demander une vérification", e, "CONTACT_SUPPORT", true),
          "block"
        );
        track("conflict_result", { position: e.position, bulb: e.original_bulb });

      } else {
        html = box(headHtml + "<p>Cette position n'est pas référencée pour cette configuration.</p>", "warn");
      }

      resultEl.innerHTML = html;
      resultEl.hidden = false;
      track("fitment_result_displayed", { position: e.position, status: e.status });

      resultEl.querySelectorAll("[data-v2-lead]").forEach(function (a) {
        a.addEventListener("click", function () {
          track("verification_requested", { request_type: a.getAttribute("data-v2-lead") });
        });
      });
    }

    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
        return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c];
      });
    }

    function uniq(a) {
      var o = {}, r = [];
      a.forEach(function (x) {
        if (!o[x]) {
          o[x] = 1;
          r.push(x);
        }
      });
      return r;
    }
  }

  document.querySelectorAll("[data-lic-selector-v2]").forEach(init);
})();
